/*
* tool
* */
import { fullScreen, isFullScreen } from "@/utils/full-screen";


export const full_screen = fullScreen;
export const is_full_screen = isFullScreen;